import { createAction } from '@reduxjs/toolkit';

export const expandCard = createAction<void, 'EXPAND_CARD'>('EXPAND_CARD');
export const collapseCard = createAction<void, 'COLLAPSE_CARD'>('COLLAPSE_CARD');
export const showRemovalConfirmation = createAction<void, 'SHOW_REMOVAL_CONFIRMATION'>('SHOW_REMOVAL_CONFIRMATION');
export const hideRemovalConfirmation = createAction<void, 'HIDE_REMOVAL_CONFIRMATION'>('HIDE_REMOVAL_CONFIRMATION');
export const showCardAddedMessage = createAction<void, 'SHOW_CARD_ADDED_MESSAGE'>('SHOW_CARD_ADDED_MESSAGE');
export const hideCardAddedMessage = createAction<void, 'HIDE_CARD_ADDED_MESSAGE'>('HIDE_CARD_ADDED_MESSAGE');
